const ragLevelsPerColor = {
  red: "high",
  amber: "moderate",
  green: "low",
};

export default ragLevelsPerColor;
